<form [formGroup]="form">
    <div class="row g-6">
        <div class="col-12 col-lg-12 mt-8">
            <app-input label="ชื่อที่อยู่" name="name" formControlName="name" placeholder="บ้าน/โรงเรียน"
                [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error?.name"></app-input>
        </div>
        <div class="col-12 mt-2">
            <app-textarea label="รายละเอียดที่อยู่" name="address" formControlName="address"
                placeholder="บ้านเลขที่ หมู่ หมู่บ้าน ถนน" [labelMode]="LabelMode.DEFAULT" minHeightClass="min-h-100px"
                [required]="true" [error]="error?.address"></app-textarea>
        </div>
        <div class="col-md-4 mt-2">
            <app-select label="จังหวัด" placeholder="จังหวัด" name="province_id" formControlName="province_id"
                bindLabel="name_th" autocomplete="shipping locality" [labelMode]="LabelMode.DEFAULT"
                [error]="error?.province_id" [required]="true" url="/provinces"
                [appendTo]="selectAppendTo"></app-select>
        </div>
        <div class="col-md-4 mt-2">
            <app-select label="อำเภอ/เขต" placeholder="อำเภอ/เขต" name="district_id" formControlName="district_id"
                bindLabel="name_th" autocomplete="shipping region" [labelMode]="LabelMode.DEFAULT"
                [error]="error?.district_id" [required]="true" [isDisabled]="!form.value.province_id" url="/districts"
                [query]="{ province_id: form.value.province_id }" [appendTo]="selectAppendTo"></app-select>
        </div>
        <div class="col-md-4 mt-2">
            <app-select label="ตำบล/แขวง" placeholder="ตำบล/แขวง" name="sub_district_id"
                formControlName="sub_district_id" bindLabel="name_th" autocomplete="shipping sub-district"
                [labelMode]="LabelMode.DEFAULT" [error]="error?.sub_district_id" [isDisabled]="!form.value.district_id"
                [required]="true" url="/sub_districts" [query]="{ district_id: form.value.district_id }"
                [appendTo]="selectAppendTo"></app-select>
        </div>
        <div class="col-12 mt-2">
            <app-input label="รหัสไปรษณีย์" name="post_code" formControlName="post_code"
                autocomplete="shipping postal-code" placeholder="รหัสไปรษณีย์" [labelMode]="LabelMode.DEFAULT"
                [required]="true" mask="00000" [error]="error?.post_code" [isDisabled]="true"></app-input>
        </div>
    </div>
</form>